import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";
import { ListLayout } from "@/components/custom/list-layout/list-layout";

const AuditLogItemSkeleton = () => (
  <div className="flex items-center justify-between gap-2 rounded-lg border p-3 sm:gap-4 sm:p-4">
    <div className="flex min-w-0 flex-1 items-center gap-2 sm:gap-3">
      <Skeleton className="size-6 shrink-0 rounded-full" />
      <Skeleton className="h-4 w-16 shrink-0 sm:w-24" />
      <Skeleton className="h-4 w-32 sm:w-64" />
    </div>
    <Skeleton className="h-5 w-10 shrink-0 rounded-md sm:w-14" />
  </div>
);

const FiltersSkeleton = () => (
  <div className="flex flex-wrap items-start justify-between gap-3">
    <div className="flex flex-wrap gap-2 sm:gap-3">
      <Skeleton className="h-9 w-[140px] rounded-md sm:w-[180px]" />
      <Skeleton className="h-9 w-[140px] rounded-md sm:w-[180px]" />
      <Skeleton className="h-9 w-[140px] rounded-md sm:w-[180px]" />
      <Skeleton className="h-9 w-[140px] rounded-md sm:w-[180px]" />
    </div>
    <Skeleton className="h-9 w-9 shrink-0 rounded-md" />
  </div>
);

export const AuditLogsSkeleton = () => (
  <ListLayout
    description="View a complete history of actions performed in your organization. Track who did what, when, and from where."
    filters={<FiltersSkeleton />}
    title="Audit Logs"
  >
    <div className="space-y-2">
      {Array.from({ length: 10 }, (_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton list
        <AuditLogItemSkeleton key={i} />
      ))}
    </div>
  </ListLayout>
);
